import { render, staticRenderFns } from "./Card5.vue?vue&type=template&id=55695a63&"
import script from "./Card5.vue?vue&type=script&lang=js&"
export * from "./Card5.vue?vue&type=script&lang=js&"
import style0 from "./Card5.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports